<p *ngIf="translationKey" [ngClass]="ngClass">{{ translationKey | translate }}</p>
